"use strict";

export function feature_js_productdata_init(el) {
   var content = el.find('[js-content]');
    $(content).height($(content)[0].scrollHeight);

    var cooking = el.find('[js-cooking]');
    $(cooking).height($(cooking)[0].scrollHeight);
}